import { render, staticRenderFns } from "./jxlhDetail.vue?vue&type=template&id=181a733a&scoped=true&"
import script from "./jxlhDetail.vue?vue&type=script&lang=js&"
export * from "./jxlhDetail.vue?vue&type=script&lang=js&"
import style0 from "./jxlhDetail.vue?vue&type=style&index=0&id=181a733a&lang=less&scoped=true&"
import style1 from "./jxlhDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a733a",
  null
  
)

export default component.exports